import React, { FunctionComponent } from 'react';
import { Avatar as AntAvatar, AvatarProps } from 'antd';

export type { AvatarProps };

export const Avatar: FunctionComponent<AvatarProps> = (props) => {
  return <AntAvatar className="the5ers-avatar" {...props} />;
};
